import {
  ADD_TOTAL,
  ADD_TO_TICKETS,
  DECREASE,
  RESET,
  ORDER_TYPE,
  REMOVE_FROM_TICKETS,
  DISCOUNT_AMOUNT,
  DISCOUNT_TYPE,
} from "../types";

export const addTicket = (item: any) => (dispatch: any, getState: any) => {
  dispatch({
    type: ADD_TO_TICKETS,
    payload: item,
  });

  localStorage.setItem(
    "tickets",
    JSON.stringify(getState().ticketReducer.ticketItems)
  );
};

export const reduceQuantity = (item: any) => (dispatch: any, getState: any) => {
  // console.log("item", item);
  dispatch({
    type: DECREASE,
    payload: item,
  });

  localStorage.setItem(
    "tickets",
    JSON.stringify(getState().ticketReducer.ticketItems)
  );
};

export const setTotal = (total: any) => (dispatch: any, getState: any) => {
  dispatch({
    type: ADD_TOTAL,
    payload: total,
  });
  // const tot = getState().ticketReducer.total;
  localStorage.setItem("total", getState().ticketReducer.total);
};

export const resetTickets = () => (dispatch: any, getState: any) => {
  dispatch({
    type: RESET,
  });
  localStorage.removeItem("tickets");
};

export const setOrderType =
  (orderType: string) => (dispatch: any, getState: any) => {
    dispatch({
      type: ORDER_TYPE,
      payload: orderType,
    });
    localStorage.setItem("orderType", getState().ticketReducer.orderType);
  };

export const setDiscountType =
  (discountType: String) => (dispatch: any, getState: any) => {
    dispatch({
      type: DISCOUNT_TYPE,
      payload: discountType,
    });
    localStorage.setItem("discountType", getState().ticketReducer.discountType);
  };

export const setDiscountAmount =
  (amount: number) => (dispatch: any, getState: any) => {
    dispatch({
      type: DISCOUNT_AMOUNT,
      payload: amount,
    });
    localStorage.setItem(
      "discountAmount",
      getState().ticketReducer.discountAmount
    );
  };

export const removeItem = (itemCode: any) => (dispatch: any, getState: any) => {
  dispatch({
    type: REMOVE_FROM_TICKETS,
    payload: itemCode,
  });
};
